"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var useTableData_1 = require("./useTableData");
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var EmptyHistory_1 = __importDefault(require("./EmptyHistory"));
var History = function (_a) {
    var lotteryId = _a.lotteryId, settings = _a.settings;
    var data = (0, swr_hooks_1.useLotteryTicketsHistory)({ lotteryId: lotteryId }).data;
    var tableData = (0, useTableData_1.useTableData)(data, settings);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.tableContainer }, tableData.rows.length !== 0 ? (react_1.default.createElement(ui_components_1.DataTable, { data: tableData, lazy: false })) : (react_1.default.createElement(EmptyHistory_1.default, null))));
};
exports.default = History;
